module.exports = __webpack_public_path__ + "static/img/gold.b8c06f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard/league-ad-section/gold.png
// module id = 6dm5
// module chunks = 35